import type { ReactNode } from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';

import { colorPrimary, radii, spacing } from '@/theme';

export interface SurfaceTextCardProps {
  readonly children: ReactNode;
  readonly style?: StyleProp<ViewStyle>;
  readonly testID?: string;
}

export const SurfaceTextCard = ({ children, style, testID }: SurfaceTextCardProps) => (
  <View style={[styles.container, style]} testID={testID}>
    {children}
  </View>
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-start',
    backgroundColor: colorPrimary.nl0,
    borderRadius: radii.md,
    padding: spacing[4],
    width: '100%',
  },
});
